var exports = {
  "p": "staleContentWarning__iosbXC",
  "A": "commentBoxContainer__ENsp3V",
};

module.exports = exports;
